module.exports = __webpack_public_path__ + "35a6c520a392916614d01a0635d443ca.png";